import moment from "moment";
import styled from "styled-components";
import Paper from '@mui/material/Paper';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import XrInputAv from '../../components/XrInputAv.tsx';
import { ViewState } from '@devexpress/dx-react-scheduler';
import { apiGet, objectToParams, API_URL_BOOKING, API_URL_ROOM } from '../../helpers/api.ts';
import { Scheduler, DayView, Appointments, DateNavigator, TodayButton, Toolbar } from '@devexpress/dx-react-scheduler-material-ui';
import XrButtonCardMv from "../../components/XrButtonCardMv.tsx";

const DashboardPage = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);;
  const [roomOptions, setRoomOptions] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedRoom, setSelectedRoom] = useState({
    label: 'Tampilkan Semua Ruangan',
    value: null,
  });
  const [errorMessage, setErrorMessage] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [filteredSchedule, setFilteredSchedule] = useState([]);

  const onChangeSelectedRoom = (e) => {
    setSelectedRoom(e);
  }

  const onChangeCurrentDate = (e) => {
    setCurrentDate(e);
  }
  const actionCreateSubmission = () => {
    navigate('/create-submission');
  }

  const actionSubmissionList = () => {
    navigate('/submissions');
  }

  const getBookings = async () => {
    setIsLoading(true);
    setSelectedRoom({
      label: 'Tampilkan Semua Ruangan',
      value: null,
    });
    try {
      const date = moment(currentDate);
      const payload = {
        status: 1,
        start_time: `${date.format('YYYY-MM-DD')} 00:00:00`,
        end_time: `${date.format('YYYY-MM-DD')} 23:59:59`,
      };      
      const url = `${API_URL_BOOKING.FILTER_BOOKING}?${objectToParams(payload)}`;
      const request = await apiGet(url, '');
      if (request.status === 200) {
        const response = await request.json(request);
        const newSchedule = [];
        response.data.forEach(booking => {
          booking.rooms.forEach(room => {
            const startDate = moment(booking.start_date);
            const endDate = moment(booking.end_date);
            newSchedule.push({
              payload: room.room_detail,
              startDate: `${startDate.format('YYYY-MM-DD')}T${startDate.format('HH:MM')}`,
              endDate: `${endDate.format('YYYY-MM-DD')}T${endDate.format('HH:MM')}`,
              title: `${booking.description} di Ruang ${room.room_detail.room_name}`
            });
          })
        });
        setSchedule(newSchedule);
        setFilteredSchedule(newSchedule);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }

  const getRooms = async () => {
    try {
      const request = await apiGet(API_URL_ROOM.GET_ROOMS, '');
      if (request.status === 200) {
        const response = await request.json(request);
        const newOptions = [
          {
            label: 'Tampilkan Semua Ruangan',
            value: null,
          }
        ].concat(response.data.map(data => {
          return {
            label: data.room_name,
            value: data,
          };
        }));
        setRoomOptions(newOptions);
      }
    } catch (error) {
    } finally {
    }
  }

  useEffect(() => {
    getBookings();
    getRooms();
  }, []);

  useEffect(() => {
    getBookings();
  }, [currentDate]);

  useEffect(() => {
    if (selectedRoom.value === null) {
      setFilteredSchedule([...schedule]);
    } else {
      const newSchedule = [...schedule].filter(i => i.payload.id === selectedRoom.value.id);
      setFilteredSchedule(newSchedule);
    }
  }, [selectedRoom]);

  return (
    <DashboardWrapper>
      <div className='dashboard__form'>
        <div className='dashboard__form-floating'>
          <XrButtonCardMv
            title='Formulir Pengajuan'
            image='/images/illus-formulir-peminjaman.png'
            description='Ajukan peminjaman ruangan untuk mendukung kegiatan paroki.'
            onClick={actionCreateSubmission}
          />
          <br />
          <XrButtonCardMv
            title='Status Pengajuan'
            image='/images/illus-status-pengajuan.png'
            description='Lihat status formulir pengajuan peminjaman.'
            onClick={actionSubmissionList}
          />
        </div>
      </div>
      <div className='dashboard__schedule'>
        <XrInputAv
          label='Saring berdasarkan nama ruangan'
          required={true}
          disabled={isLoading}
          isLoading={isLoading}
          placeholder='Pilih nama ruangan'
          selectProps={{
            value: selectedRoom,
            options: roomOptions,
            onChange: onChangeSelectedRoom
          }}
          errorMessage={errorMessage}
        />
        
        <Paper>
          <Scheduler data={filteredSchedule}>
            <ViewState currentDate={currentDate} onCurrentDateChange={onChangeCurrentDate} />
            <DayView
              startDayHour={0}
              endDayHour={24}
            />
            <Appointments />
            <Toolbar />
            <DateNavigator />
            <TodayButton />
          </Scheduler>
        </Paper>
      </div>
    </DashboardWrapper>
  )
}

const DashboardWrapper = styled.div`
  display: flex;
  min-width: 100%;
  min-height: 100vh;

  & .dashboard__form,
  & .dashboard__schedule {
    padding: 40px;
  }

  & .dashboard__form {
    width: 500px;
    &-floating {
      top: 40px;
      position: sticky;
    }
  }

  & .dashboard__schedule {
    width: calc(100% - 500px);
  }
`;

export default DashboardPage;